import { render, staticRenderFns } from "./IndemnityPriceClinicTemplateEditModal.vue?vue&type=template&id=58de8e76&scoped=true"
import script from "./IndemnityPriceClinicTemplateEditModal.vue?vue&type=script&lang=js"
export * from "./IndemnityPriceClinicTemplateEditModal.vue?vue&type=script&lang=js"
import style0 from "./IndemnityPriceClinicTemplateEditModal.vue?vue&type=style&index=0&id=58de8e76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58de8e76",
  null
  
)

export default component.exports